// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2H_Lt","bigColWidth":"Table_bigColWidth__xd_tn","biggerColWidth":"Table_biggerColWidth__hVmiw","row":"Table_row__lWiWK","col":"Table_col__1-ep1"};